<script>
  let { formHeaderText, strengthHeaderText, forms, evenodd = true, dataTestId = 'similar-drug-table' } = $props();
</script>

<div class="bg-white w-full" class:shadow-y-sm={evenodd}>
  <div class="py-2 grid grid-cols-2" class:px-4={evenodd}>
    <div class="text-sm font-medium">{formHeaderText}</div>
    <div class="text-sm font-medium">{strengthHeaderText}</div>
  </div>
  <div data-testid={`${dataTestId}-row`}>
    {#each Object.entries(forms) as [form, strengths]}
      <div
        class="leading-loose py-2 grid grid-cols-2"
        class:px-4={evenodd}
        class:odd:bg-gray-pale={evenodd}
        class:border-t={!evenodd}
        class:border-gray-iron={!evenodd}
      >
        <div class="pr-4">{form}</div>
        <div>
          {#if Array.isArray(strengths)}
            {#each strengths as strength}
              <div data-testid="{dataTestId}-strengths-cell">
                {strength}
              </div>
            {/each}
          {:else if typeof strengths === 'string'}
            <div data-testid="{dataTestId}-strengths-cell">{strengths}</div>
          {/if}
        </div>
      </div>
    {/each}
  </div>
</div>
